<template>
    <div id="app">
        <loading :active.sync="isLoading"></loading>
        <Alert />
        <BaseFullModal :dialogConfig="dialogConfig" />
        <router-view></router-view>
    </div>
</template>

<script>
import '@progress/kendo-theme-bootstrap/dist/all.css'
import './assets/scss/coreUI/style.scss'
import { mapGetters } from 'vuex'

import Alert from '@/components/Common/AlertMessage'
import BaseFullModal from '@/components/Common/BaseFullModal'

export default {
  name: "App",
  components: {
    Alert,BaseFullModal
  },
  computed: {
    ...mapGetters(['isLoading','dialogConfig'])
  }
};
</script>

<style lang="scss">
@import '~mdb-ui-kit/css/mdb.min.css';

*, body {
  font-family: '微軟正黑體';
}

.k-danger {
  border-color: #dc3545;
  background-color: #dc3545;
  color: white;
  &:hover {
    border-color: darken(#dc3545, 10%);
    background-color: darken(#dc3545, 10%);
    color: white;
  }
}
</style>
